import { Input } from '@finn/design-system/atoms/input';
import { getFormattedDate } from '@finn/platform-modules';
import { Ref } from 'react';
import { ControllerProps } from 'react-hook-form';
import { IMaskMixin } from 'react-imask';

import { Field } from '../types';
import { useFormField } from './form';

type DateInputFieldProps = Field & {
  type: 'date-custom' | 'date-input';
} & Parameters<ControllerProps['render']>['0']['field'];

const IMaskInput = IMaskMixin(({ inputRef, defaultValue, ...props }) => {
  return (
    <Input
      ref={inputRef as Ref<HTMLInputElement>}
      defaultValue={defaultValue as string}
      {...props}
    />
  );
});

export const DateCustomField = ({ ...field }: DateInputFieldProps) => {
  const { error } = useFormField();

  const value =
    typeof field.value === 'string' && field.value?.includes('-')
      ? getFormattedDate(field.value, 'DD.MM.YYYY')
      : field?.value;

  const formattedValue =
    value instanceof Date ? getFormattedDate(field.value, 'DD.MM.YYYY') : value;

  return (
    <IMaskInput
      {...field}
      mask="00.00.0000"
      lazy={false}
      placeholderChar="_"
      value={formattedValue}
      shouldShowLabelAtTop
      disabled={field.disabled}
      label={field.label}
      error={error?.message}
      onAccept={(nextValue: string) => {
        if (nextValue !== formattedValue) {
          field.onChange(nextValue);
        }
      }}
    />
  );
};
